import { render, staticRenderFns } from "./RegisteredTerminals.vue?vue&type=template&id=745d7d46&"
import script from "./RegisteredTerminals.vue?vue&type=script&lang=js&"
export * from "./RegisteredTerminals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports